import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';

const PdfForm = () => {
    const [loading, setLoading] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [submitStatusType, setSubmitStatusType] = useState(null);
    const [errors, setErrors] = useState({});
    const [submitted, setSubmitted] = useState(false);

    const boxStyle = {
        flex: 1,
        minWidth: '500px',
        padding: '30px',
        border: '1px solid violet',
        backgroundColor: 'rgba(238, 130, 238, 0.1)',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    };

    const inputFieldStyle = {
        backgroundColor: 'transparent',
        fontSize: '1.6rem',
        border: '1px solid violet',
    };

    const validateForm = (data) => {
        const newErrors = {};
        const requiredFields = [
            'first_name', 'last_name', 'email', 'phone_number', 'whatsapp_number',
            'profession', 'city', 'message'
        ];

        requiredFields.forEach((field) => {
            if (!data[field] || data[field].trim() === '') {
                newErrors[field] = [`${field.replace('_', ' ')} is required.`];
            }
        });

        // Simple email check
        if (data.email && !/\S+@\S+\.\S+/.test(data.email)) {
            newErrors.email = ['Please enter a valid email address.'];
        }

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSubmitStatus(null);
        setSubmitStatusType(null);
        setErrors({});

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        // Validate fields
        const validationErrors = validateForm(data);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setSubmitStatus('Please fill in all required fields.');
            setSubmitStatusType('danger');
            setLoading(false);
            return;
        }

        try {
            // Simulate API success
            const success = true;
            if (success) {
                setSubmitStatus('Form submitted successfully!');
                setSubmitStatusType('success');
                setSubmitted(true); // Hide form and show link
            }
        } catch (error) {
            setSubmitStatus('Network or server error. Please try again.');
            setSubmitStatusType('danger');
        } finally {
            setLoading(false);
        }
    };

    const hasError = (field) => errors && errors[field] && errors[field].length > 0;

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={10} lg={8}>
                    <h3 className="mb-3 text-center">Contact Details</h3>

                    {/* Show link after submission */}
                    {submitted ? (
                        <Alert variant="success" className="text-center">
                            <h3>🎉 Thank you for submitting! </h3>
                            <a target='BLANK' href="https://drive.google.com/file/d/1IwowqeRXfq3X7XKvNYxanT_fyqcsnRfF/view" className="btn-default mt-3">
                                Download PDF
                            </a>
                        </Alert>
                    ) : (
                        <Form className='px-5' style={boxStyle} onSubmit={handleSubmit} noValidate>
                            {/* First & Last Name */}
                            <Row>
                                <Col>
                                    <Form.Group className="mb-3" controlId="first_name">
                                        <Form.Label>First Name *</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="first_name"
                                            style={inputFieldStyle}
                                            isInvalid={hasError('first_name')}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {hasError('first_name') && errors.first_name[0]}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group className="mb-3" controlId="last_name">
                                        <Form.Label>Last Name *</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="last_name"
                                            style={inputFieldStyle}
                                            isInvalid={hasError('last_name')}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {hasError('last_name') && errors.last_name[0]}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* Email */}
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>Email *</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    style={inputFieldStyle}
                                    isInvalid={hasError('email')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {hasError('email') && errors.email[0]}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Phone Number */}
                            <Form.Group className="mb-3" controlId="phone_number">
                                <Form.Label>Phone Number *</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="phone_number"
                                    style={inputFieldStyle}
                                    isInvalid={hasError('phone_number')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {hasError('phone_number') && errors.phone_number[0]}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Whatsapp Number */}
                            <Form.Group className="mb-3" controlId="whatsapp_number">
                                <Form.Label>Whatsapp Number *</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="whatsapp_number"
                                    style={inputFieldStyle}
                                    isInvalid={hasError('whatsapp_number')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {hasError('whatsapp_number') && errors.whatsapp_number[0]}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Profession */}
                            <Form.Group className="mb-3" controlId="profession">
                                <Form.Label>Profession *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="profession"
                                    style={inputFieldStyle}
                                    isInvalid={hasError('profession')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {hasError('profession') && errors.profession[0]}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* City */}
                            <Form.Group className="mb-3" controlId="city">
                                <Form.Label>City *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="city"
                                    style={inputFieldStyle}
                                    isInvalid={hasError('city')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {hasError('city') && errors.city[0]}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Message */}
                            <Form.Group className="mb-3" controlId="message">
                                <Form.Label>Message *</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="message"
                                    style={{ ...inputFieldStyle, height: '120px' }}
                                    isInvalid={hasError('message')}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {hasError('message') && errors.message[0]}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/* Submit Button */}
                            <div className="text-center mt-4">
                                <Button className="btn-default" variant="primary" type="submit" disabled={loading}>
                                    {loading ? (
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />{' '}
                                            Submitting...
                                        </>
                                    ) : (
                                        'Submit'
                                    )}
                                </Button>
                            </div>

                            {submitStatus && (
                                <Alert variant={submitStatusType} className="mt-4">
                                    {submitStatus}
                                </Alert>
                            )}
                        </Form>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default PdfForm;
